<template>
  <div>
    <footer class="app-footer">
      <div class="container text-center py-3">
        <!--/* This template is free as long as you keep the footer attribution link. If you'd like to use the template without the attribution link, you can buy the commercial license via our website: themes.3rdwavemedia.com Thank you for your support. :) */-->
        <small class="copyright"
        
          >Copyright © {{ currentYear }}
          <a
            class="app-link"
            href="http://run.edu.ng"
            target="_blank"
            > Redeemer's University. </a
          >
          All Rights Reserved. </small
        >
      </div>
    </footer>
    <!--//app-footer-->
  </div>
</template>

<script>
export default {
  name: "Footer",
  data(){
    return{
      currentYear: new Date().getFullYear()
    }
  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
